module.exports = __webpack_public_path__ + "static/derrick_rose-74a6fbacb107f7bbb6358a345c96703f.jpg";